// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"a677a003","453":"eddfbbfd"}[chunkId] + ".chunk.js";
};